/** Vết một lần chạy thử: từng khối, trạng thái, tóm tắt; bấm để xem đầu vào/đầu ra (như n8n). */
import { useState } from 'react'
import { CheckCircle2, XCircle, Clock, SkipForward, ChevronRight } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { RunStep, WorkflowRun } from '@/lib/automation-v2/types'

const NHAN_KHOI: Record<RunStep['kind'], string> = { source: 'Nguồn', mapping: 'Ánh xạ', condition: 'Điều kiện', delay: 'Chờ', action: 'Hành động' }

export function BieuTuongBuoc({ status, className = 'h-4 w-4' }: { status: RunStep['status']; className?: string }) {
  if (status === 'ok') return <CheckCircle2 className={cn(className, 'text-success')} />
  if (status === 'fail') return <XCircle className={cn(className, 'text-destructive')} />
  if (status === 'wait') return <Clock className={cn(className, 'text-warning')} />
  return <SkipForward className={cn(className, 'text-muted-foreground')} />
}

export function ChiTietLanChay({ run, onChonKhoi }: { run: WorkflowRun; onChonKhoi?: (nodeId: string) => void }) {
  const [mo, setMo] = useState<string | null>(null)
  return (
    <div className="max-h-[70vh] space-y-1.5 overflow-y-auto pr-1">
      {run.steps.map((s, i) => (
        <div key={`${s.nodeId}-${i}`} className="rounded-md border">
          <button type="button" className="flex w-full items-start gap-2 p-2 text-left text-xs hover:bg-accent/40" onClick={() => { setMo(mo === s.nodeId ? null : s.nodeId); onChonKhoi?.(s.nodeId) }}>
            <BieuTuongBuoc status={s.status} className="mt-0.5 h-4 w-4 shrink-0" />
            <span className="min-w-0 flex-1">
              <span className="flex flex-wrap items-center gap-1.5"><Badge variant="outline" className="px-1.5 py-0 text-[10px]">{NHAN_KHOI[s.kind]}</Badge><span className="font-medium">{s.label}</span>{s.branch && <Badge variant={s.branch === 'true' ? 'success' : 'secondary'} className="px-1.5 py-0 text-[10px]">nhánh {s.branch === 'true' ? 'Đúng' : 'Sai'}</Badge>}</span>
              <span className="mt-0.5 block whitespace-pre-wrap text-muted-foreground">{s.summary}</span>
            </span>
            <ChevronRight className={cn('mt-0.5 h-3.5 w-3.5 shrink-0 text-muted-foreground transition-transform', mo === s.nodeId && 'rotate-90')} />
          </button>
          {mo === s.nodeId && (s.input !== undefined || s.output !== undefined) && (
            <div className="grid gap-2 border-t bg-muted/30 p-2 text-[11px] sm:grid-cols-2">
              <div><p className="mb-1 font-medium text-muted-foreground">Đầu vào</p><pre className="max-h-48 overflow-auto rounded bg-background p-2">{JSON.stringify(s.input ?? null, null, 2)}</pre></div>
              <div><p className="mb-1 font-medium text-muted-foreground">Đầu ra</p><pre className="max-h-48 overflow-auto rounded bg-background p-2">{JSON.stringify(s.output ?? null, null, 2)}</pre></div>
            </div>
          )}
        </div>
      ))}
      <details className="rounded-md border p-2 text-[11px]">
        <summary className="cursor-pointer font-medium text-muted-foreground">Ngữ cảnh cuối (biến dùng được trong {'{{...}}'})</summary>
        <pre className="mt-1 max-h-64 overflow-auto rounded bg-muted/30 p-2">{JSON.stringify(run.context, null, 2)}</pre>
      </details>
    </div>
  )
}
